import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { AuthorSettingsSaveRequest } from '../../requests/platform/author-settings-save.request';
import { AuthorSettingsGetResponse } from '../../responses/platform/author-settings-get.response';
import { ReturnStruct } from '../../structs/return.struct';
import { CouponTargetsResponse } from '../../responses/platform/coupon-targets.response';
import { CouponApplyTargetsRequest } from '../../requests/platform/coupon-apply-targets.request';

@Injectable({
    providedIn: 'root'
})
export class AuthorSettingsService extends CommonService {
    private readonly baseUrl = environment.urlApiPlatform + 'AuthorSettings/';

    constructor(private http: HttpClient) {
        super();
    }

    /** GET /AuthorSettings/get */
    public Get(): Observable<AuthorSettingsGetResponse> {
        const url = this.baseUrl + 'get';
        return this.http
            .get<AuthorSettingsGetResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    /** POST /AuthorSettings/save */
    public Save(request: AuthorSettingsSaveRequest): Observable<ReturnStruct> {
        const url = this.baseUrl + 'save';
        return this.http
            .post<ReturnStruct>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    // GET /AuthorSettings/coupon/targets/{idCoupon}
    // Retorna os livros e kits do autor, com flags "selected"
    public GetCouponTargets(idCoupon: number): Observable<CouponTargetsResponse> {
        const url = this.baseUrl + 'coupon/targets/' + idCoupon;
        return this.http
            .get<CouponTargetsResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    // POST /AuthorSettings/coupon/apply
    // Salva os kits selecionados para o cupom
    public SaveCouponTargets(request: CouponApplyTargetsRequest): Observable<ReturnStruct> {
        const url = this.baseUrl + 'coupon/apply';
        return this.http
            .post<ReturnStruct>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
